import { supabase } from './supabase';

/** J6: motives offered when setting work aside (labels only, no explanation). */
export type WorkGuidanceMotif = 'done' | 'wrong_target' | 'not_priority' | 'too_generic' | 'other';

export const WORK_GUIDANCE_MOTIF_LABELS: Record<WorkGuidanceMotif, string> = {
  done: 'Déjà fait',
  wrong_target: 'Pas la bonne cible',
  not_priority: 'Pas ma priorité',
  too_generic: 'Trop générique',
  other: 'Autre',
};

export const WORK_GUIDANCE_MOTIFS = Object.keys(WORK_GUIDANCE_MOTIF_LABELS) as WorkGuidanceMotif[];

export interface WorkGuidanceNote {
  id: string;
  scope: 'topic' | 'thread' | 'subject' | 'person';
  motif: WorkGuidanceMotif;
  workTitle: string | null;
  note: string | null;
  createdAt: string;
}

/** The person's own guidance that Domino reads (not the per-work records). */
export const loadMyWorkGuidance = async (): Promise<WorkGuidanceNote[]> => {
  const { data, error } = await supabase.from('work_guidance_notes')
    .select('id,scope,motif,work_title,note,created_at')
    .neq('scope', 'topic')
    .order('created_at', { ascending: false });
  if (error) throw new Error('Les consignes ne sont pas accessibles pour le moment.');
  return ((data ?? []) as Array<Record<string, unknown>>).map((row) => ({
    id: String(row.id),
    scope: row.scope as WorkGuidanceNote['scope'],
    motif: row.motif as WorkGuidanceMotif,
    workTitle: (row.work_title as string | null) ?? null,
    note: (row.note as string | null) ?? null,
    createdAt: String(row.created_at),
  }));
};

export const removeWorkGuidance = async (id: string): Promise<void> => {
  const { error } = await supabase.from('work_guidance_notes').delete().eq('id', id);
  if (error) throw new Error('La consigne n’a pas pu être retirée.');
};
